<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<g clip-path="url(#clip0_740_8320)">
			<path
				d="M1 3.8L3.33333 3.8M3.33333 3.8L15 3.8M3.33333 3.8L3.33333 13.6C3.33333 13.9713 3.47381 14.3274 3.72386 14.5899C3.97391 14.8525 4.31304 15 4.66667 15L11.3333 15C11.687 15 12.0261 14.8525 12.2761 14.5899C12.5262 14.3274 12.6667 13.9713 12.6667 13.6L12.6667 3.8L3.33333 3.8ZM5.33333 3.8V2.4C5.33333 2.0287 5.47381 1.6726 5.72386 1.41005C5.97391 1.1475 6.31304 1 6.66667 1L9.33333 1C9.68696 1 10.0261 1.1475 10.2761 1.41005C10.5262 1.6726 10.6667 2.0287 10.6667 2.4V3.8M6.66667 7.3V11.5M9.33333 7.3L9.33333 11.5"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="square"
			/>
		</g>
		<defs>
			<clipPath id="clip0_740_8320">
				<rect width="16" height="16" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
</template>
